import type { DataFeature, DataLayer } from '../shared/data-layer.js';
import { dataFeatureSourceName, isAreaFeature } from '../shared/data-layer-display.js';
import { t } from './i18n.js';

export function dataFeatureName(feature: DataFeature, layer?: Pick<DataLayer, 'display'>): string {
  return dataFeatureSourceName(feature, layer) ?? t(isAreaFeature(feature) ? 'data_layers.unnamed_area' : 'data_layers.unnamed_item');
}
